<template>
  <Page>
    <template #header>
      <h1 class="title is-3 has-text-centered">Suivi de la journée</h1>
    </template>
    <template #body>
      <div class="container">
        <!-- Navigation et sélection de personne -->
        <div class="columns is-mobile mb-4">
          <div class="column is-6">
            <div class="buttons has-addons">
              <button class="button is-small navigation-btn" @click="previous()">
                <span class="icon is-small">
                  <i class="fas fa-chevron-left"></i>
                </span>
                <span>Précédent</span>
              </button>
              <button class="button is-small navigation-btn" @click="next()">
                <span>Suivant</span>
                <span class="icon is-small">
                  <i class="fas fa-chevron-right"></i>
                </span>
              </button>
            </div>
          </div>
          <div class="column is-6">
            <div class="buttons has-addons">
              <button 
                class="button is-small" 
                :class="currentPerson === 1 ? 'is-info' : 'is-light'"
                @click="choosePerson(1)"
              >
                Nicolas
              </button>
              <button 
                class="button is-small" 
                :class="currentPerson === 2 ? 'is-danger' : 'is-light'"
                @click="choosePerson(2)"
              >
                Elodie
              </button>
            </div>
          </div>
        </div>

        <!-- En-tête avec informations de la journée -->
        <div class="card mb-4">
          <div class="card-content">
            <div class="content has-text-centered">
              <h2 class="title is-4 mb-2">
                {{ currentPerson == 1 ? 'Nicolas' : 'Elodie' }}
              </h2>
              <p class="subtitle is-6 has-text-grey mt-4">
                {{ currentDate || 'Aucune date sélectionnée' }}
              </p>
            </div>
          </div>
        </div>

        <!-- Tableau des portions -->
        <div class="card mb-4">
          <div class="card-header">
            <p class="card-header-title">
              Portions consommées
              <span v-if="loading" class="icon is-small ml-2">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
            </p>
            <div class="card-header-icon">
              <button 
                class="button is-small is-light" 
                @click="showMacros = !showMacros"
                :title="showMacros ? 'Masquer les macros' : 'Afficher les macros'"
              >
                <span class="icon is-small">
                  <i :class="showMacros ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </span>
                <span>{{ showMacros ? 'Masquer' : 'Afficher' }} macros</span>
              </button>
            </div>
          </div>
          <div class="card-content">
            <div v-if="loading && !loaded" class="has-text-centered py-6">
              <span class="icon is-large">
                <i class="fas fa-spinner fa-spin"></i>
              </span>
              <p class="mt-2">Chargement...</p>
            </div>
            <div v-else class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th v-show="showMacros" class="has-background-primary-light has-text-centered">G</th>
                    <th v-show="showMacros" class="has-background-danger-light has-text-centered">L</th>
                    <th v-show="showMacros" class="has-background-success-light has-text-centered">P</th>
                    <th class="has-background-info-light has-text-centered">Kcal</th>
                    <th class="has-text-centered">Gr</th>
                    <th class="has-text-centered">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="portion in portions" :key="portion.id">
                    <td>{{ portion.name }}</td>
                    <td v-show="showMacros" class="has-background-primary-light has-text-centered">{{ portion.glucide }}</td>
                    <td v-show="showMacros" class="has-background-danger-light has-text-centered">{{ portion.lipide }}</td>
                    <td v-show="showMacros" class="has-background-success-light has-text-centered">{{ portion.proteine }}</td>
                    <td class="has-background-info-light has-text-centered">{{ portion.kcal }}</td>
                    <td class="has-text-centered">{{ portion.quantity }}</td>
                    <td class="has-text-centered">
                      <button 
                        class="button is-small is-danger is-light" 
                        @click="deletePortion(portion.id)"
                        title="Supprimer"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-trash"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="portions.length === 0">
                    <td :colspan="showMacros ? 7 : 4" class="has-text-centered has-text-grey">
                      Aucune portion enregistrée pour cette journée
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr class="has-background-light has-text-weight-bold">
                    <td>Total</td>
                    <td v-show="showMacros" class="has-background-primary-light has-text-centered">{{ total.glucide || 0 }}</td>
                    <td v-show="showMacros" class="has-background-danger-light has-text-centered">{{ total.lipide || 0 }}</td>
                    <td v-show="showMacros" class="has-background-success-light has-text-centered">{{ total.proteine || 0 }}</td>
                    <td class="has-background-info-light has-text-centered">{{ total.kcal || 0 }}</td>
                    <td></td>
                    <td></td>
                  </tr>
                  <!-- <tr v-if="currentPerson === 1" class="has-background-warning-light has-text-weight-bold">
                    <td>Objectif</td>
                    <td v-show="showMacros" class="has-background-primary-light has-text-centered">306</td>
                    <td v-show="showMacros" class="has-background-danger-light has-text-centered">49.6</td>
                    <td v-show="showMacros" class="has-background-success-light has-text-centered">124</td>
                    <td class="has-background-info-light has-text-centered">2168</td>
                    <td></td>
                    <td></td>
                  </tr> -->
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <!-- Formulaire d'ajout de portion personnalisée -->
        <div class="card mb-4">
          <div class="card-header">
            <p class="card-header-title">
              Ajouter une portion personnalisée
            </p>
          </div>
          <div class="card-content">
            <div class="columns is-multiline">
              <div class="column is-4">
                <div class="field">
                  <label class="label is-small">Nom</label>
                  <div class="control">
                    <input 
                      type="text" 
                      v-model="customName" 
                      placeholder="Nom de l'aliment" 
                      class="input is-small"
                    >
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field">
                  <label class="label is-small">Calories</label>
                  <div class="control">
                    <input 
                      type="number" 
                      v-model="customCalorie" 
                      placeholder="Calories" 
                      class="input is-small"
                    >
                  </div>
                </div>
              </div>
              <div class="column is-4">
                <div class="field">
                  <label class="label is-small">Grammes</label>
                  <div class="control">
                    <input 
                      type="number" 
                      v-model="customGrammes" 
                      placeholder="Grammes" 
                      class="input is-small"
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control add-portion-btn-container">
                <button 
                  @click="addCustomPortion" 
                  class="button is-primary is-small add-portion-btn"
                  :disabled="!customName || !customCalorie || !customGrammes"
                >
                  <span class="icon is-small">
                    <i class="fas fa-plus"></i>
                  </span>
                  <span>Ajouter</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Bouton pour afficher la liste des produits -->
        <div class="has-text-centered mb-4">
          <button 
            @click="showPortions" 
            class="button is-info"
          >
            <span class="icon">
              <i class="fas fa-search"></i>
            </span>
            <span>{{ showAddPortion ? 'Masquer' : 'Ajouter' }} une portion depuis la base</span>
          </button>
        </div>

        <!-- Section de recherche et sélection de produits -->
        <div v-if="showAddPortion" class="card">
          <div class="card-header">
            <p class="card-header-title">
              Rechercher un produit
            </p>
          </div>
          <div class="card-content">
            <div class="field">
              <label class="label is-small">Recherche</label>
              <div class="control has-icons-left">
                <input 
                  type="text" 
                  v-model="search" 
                  placeholder="Tapez le nom d'un produit..." 
                  class="input"
                >
                <span class="icon is-small is-left">
                  <i class="fas fa-search"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <label class="label is-small">Grammes par portion</label>
              <div class="control">
                <input 
                  type="number" 
                  v-model="grammesOfPortion" 
                  placeholder="100" 
                  class="input is-small"
                  style="max-width: 150px;"
                >
              </div>
            </div>

            <div class="table-container">
              <table class="table is-fullwidth is-striped is-hoverable">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th v-show="showMacros" class="has-background-primary-light has-text-centered">G</th>
                    <th v-show="showMacros" class="has-background-danger-light has-text-centered">L</th>
                    <th v-show="showMacros" class="has-background-success-light has-text-centered">P</th>
                    <th class="has-background-info-light has-text-centered">Kcal</th>
                    <th class="has-text-centered">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="product in allProducts" :key="product.id">
                    <td>{{ product.name }}</td>
                    <td v-show="showMacros" class="has-background-primary-light has-text-centered">{{ product.glucide }}</td>
                    <td v-show="showMacros" class="has-background-danger-light has-text-centered">{{ product.lipide }}</td>
                    <td v-show="showMacros" class="has-background-success-light has-text-centered">{{ product.proteine }}</td>
                    <td class="has-background-info-light has-text-centered">{{ product.kcal }}</td>
                    <td class="has-text-centered">
                      <button 
                        class="button is-small is-success is-light" 
                        @click="addPortion(product.id)"
                        :disabled="!grammesOfPortion"
                        title="Ajouter"
                      >
                        <span class="icon is-small">
                          <i class="fas fa-plus"></i>
                        </span>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="allProducts.length === 0">
                    <td :colspan="showMacros ? 6 : 3" class="has-text-centered has-text-grey">
                      Aucun produit trouvé
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Page>
</template>

<script>
import axios from "axios";
import Page from "../Page.vue";
import {base} from "../api";
import {IonIcon} from '@ionic/vue';
import {chevronBackOutline} from 'ionicons/icons';

export default {
  name: "Home",
  components: {Page, IonIcon},
  data() {
    return {
      loaded: false,
      loading: false,
      chevronBackOutline,
      currentPerson: 1,
      portions: [],
      total: {},
      percent: {},
      showAddPortion: false,
      showMacros: false,
      allProducts: [],
      searchedProducts: [],
      grammesOfPortion: 100,
      currentOffset: 0,
      currentDate: '',
      search: '',
      objectif: {nicolas: {kcal: 2343, lipide: 234, proteine: 937, glucide: 1171}},
      customCalorie: '',
      customGrammes: '',
      customName: ''
    }
  },

  async mounted() {
    await this.getJourney();
  },
  watch: {
    async search(newValue, oldValue) {
      this.allProducts = this.searchedProducts.filter(product => product.name.toLowerCase().includes(newValue.toLowerCase()))
    }
  },
  methods: {
    choosePerson(id) {
      this.currentPerson = id;
      this.getJourney();
    },
    async addPortion(idProduct) {
      if (!this.grammesOfPortion || this.grammesOfPortion <= 0) {
        alert('Veuillez entrer une quantité valide');
        return;
      }
      
      this.loading = true;
      try {
        let config = {
          headers: {
            'x-person': this.currentPerson,
          }
        }
        const request = {"quantity": this.grammesOfPortion, 'productId': idProduct};
        await axios.post(base + '/portion', request, config);
        await this.getJourney();
      } catch (error) {
        console.error('Erreur lors de l\'ajout de la portion:', error);
        alert('Erreur lors de l\'ajout de la portion');
      } finally {
        this.loading = false;
      }
    },
    async addProduct() {
      const response = await axios.post(base + '/product', {
        'name': this.product.name,
        'kcal': this.product.kcal,
        'proteine': this.product.proteine,
        'lipide': this.product.lipide,
        'glucide': this.product.glucide,
      })
      this.product = {};
    },
    async getAllProducts() {
      try {
        const response = await axios.get(base + '/products');
        this.allProducts = response.data;
        this.searchedProducts = response.data;
      } catch (error) {
        console.error('Erreur lors du chargement des produits:', error);
        this.allProducts = [];
        this.searchedProducts = [];
      }
    },
    async showPortions() {
      this.showAddPortion = !this.showAddPortion;
      if (this.showAddPortion) {
        await this.getAllProducts();
      }
    },

    async previous() {
      this.currentOffset = this.currentOffset + 1;
      await this.getJourney();
    },
    async next() {
      this.currentOffset = this.currentOffset - 1 <= 0 ? 0 : this.currentOffset - 1;
      await this.getJourney();
    },
    async getJourney() {
      this.loading = true;
      try {
        let config = {
          headers: {
            'x-person': this.currentPerson,
          }
        }

        const response = await axios.get(base + '/journeys?offset=' + this.currentOffset, config);
        const result = response.data;
        this.portions = [];
        this.total = {};
        this.currentDate = '';
        
        if (result.date) {
          this.currentDate = result.date;
        }
        if (result.portions && result.portions.length > 0) {
          this.currentDate = result.date;
          this.portions = result.portions;
          this.total = result.total;
        }
        this.loaded = true;
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error);
        this.portions = [];
        this.total = {};
        this.currentDate = '';
      } finally {
        this.loading = false;
      }
    },
    async deletePortion(id) {
      if (!confirm('Êtes-vous sûr de vouloir supprimer cette portion ?')) {
        return;
      }
      
      this.loading = true;
      try {
        await axios.delete(base + '/portion/' + id);
        await this.getJourney();
      } catch (error) {
        console.error('Erreur lors de la suppression:', error);
        alert('Erreur lors de la suppression de la portion');
      } finally {
        this.loading = false;
      }
    },
    async addCustomPortion() {
      if (!this.customName || !this.customCalorie || !this.customGrammes) {
        alert('Veuillez remplir tous les champs');
        return;
      }
      
      if (this.customCalorie <= 0 || this.customGrammes <= 0) {
        alert('Les valeurs doivent être positives');
        return;
      }
      
      this.loading = true;
      try {
        let config = {
          headers: {
            'x-person': this.currentPerson,
          }
        }
        await axios.post(base + '/portion-custom', {
          'quantity': this.customGrammes,
          'calorie': this.customCalorie,
          'name': this.customName
        }, config);
        
        // Réinitialiser le formulaire
        this.customName = '';
        this.customCalorie = '';
        this.customGrammes = '';
        
        await this.getJourney();
      } catch (error) {
        console.error('Erreur lors de l\'ajout de la portion personnalisée:', error);
        alert('Erreur lors de l\'ajout de la portion personnalisée');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.card {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.card-header-title {
  font-weight: 600;
  color: #495057;
}

.table th {
  font-weight: 600;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table td {
  vertical-align: middle;
}

.buttons.has-addons .button {
  border-radius: 0;
}

.buttons.has-addons .button:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.buttons.has-addons .button:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.button {
  transition: all 0.2s ease;
}

.button:hover {
  transform: translateY(-1px);
}

.button:active {
  transform: translateY(0);
}

.input {
  border-radius: 4px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.input:focus {
  border-color: #3273dc;
  box-shadow: 0 0 0 0.125em rgba(50, 115, 220, 0.25);
}

.table-container {
  border-radius: 4px;
  overflow: hidden;
}

.table.is-hoverable tbody tr:hover {
  background-color: #f8f9fa;
}

/* Responsive design */
@media (max-width: 768px) {
  .columns.is-mobile {
    margin: 0;
  }
  
  .column {
    padding: 0.5rem;
  }
  
  .table-container {
    overflow-x: auto;
  }
  
  .table {
    font-size: 0.875rem;
  }
  
  .card-content {
    padding: 1rem;
  }
  
  .buttons.has-addons {
    justify-content: center;
  }
}

/* Animations */
.card {
  animation: fadeInUp 0.3s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Custom colors for better contrast */
.has-background-primary-light {
  background-color: #e3f2fd !important;
  color: #1976d2;
}

.has-background-danger-light {
  background-color: #ffebee !important;
  color: #d32f2f;
}

.has-background-success-light {
  background-color: #e8f5e8 !important;
  color: #388e3c;
}

.has-background-info-light {
  background-color: #e1f5fe !important;
  color: #0288d1;
}

.has-background-warning-light {
  background-color: #fff3e0 !important;
  color: #f57c00;
}

/* Loading states */
.button.is-loading {
  pointer-events: none;
}

/* Empty state styling */
.has-text-grey {
  color: #6c757d !important;
  font-style: italic;
}

/* Navigation buttons same width */
.navigation-btn {
  flex: 1;
  min-width: 0;
  justify-content: center;
}

.navigation-btn .icon {
  flex-shrink: 0;
}

/* Add portion button */
.add-portion-btn-container {
  display: flex;
  justify-content: center;
}

.add-portion-btn {
  min-width: 150px;
}

/* Better spacing for mobile */
@media (max-width: 768px) {
  .add-portion-btn {
    width: 100%;
    min-width: 100%;
  }
}

@media (max-width: 480px) {
  .title.is-3 {
    font-size: 1.5rem;
  }
  
  .title.is-4 {
    font-size: 1.25rem;
  }
  
  .button {
    font-size: 0.875rem;
  }
}
</style>